import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue'

import TripShareSectionCanEdit from './TripShareSectionCanEdit.vue'
import TripShareSectionViewOnly from './TripShareSectionViewOnly.vue'
import { useSelectedTrip } from '@/composables/trip'
import { thumbnailImage, MILE_FACTOR, logEvent } from '@/utils/utility-manager'
import { getDateFromLambusDate } from '@/utils/date-utils'
import { calculateTotalDistance } from '@/utils/transportation'
import { useLocalTripSettings } from '@/composables/trip-settings'
import { DistanceUnit } from '@/utils/enums'

interface Props {
  value?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TripShareSlideOver',
  props: {
    value: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value?: boolean
};





const trip = useSelectedTrip()

const tripImage = trip.value.theme.startsWith('home')
  ? require('~/assets/themes/' + trip.value.theme + '.png')
  : thumbnailImage(trip.value.theme, 1024)

// Trip Information ------------------------------------------------------------

// Trip Days
const tripDays = getTripDays()

function getTripDays() {
  const start = getDateFromLambusDate(trip.value.startDate)
  const end = getDateFromLambusDate(trip.value.endDate)
  if (!start || !end) {
    return 0
  }

  const diffTime = Math.abs(new Date(end).getTime() - new Date(start).getTime())
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1
}

const { tripSettings } = useLocalTripSettings(trip.value._id)

// Trip Distance
const tripDistance = ref('0')

function getTripDistance() {
  const distanceInKilometers = calculateTotalDistance(trip.value)

  const decimalNumbers = distanceInKilometers > 10 ? 0 : 1
  if (tripSettings.value.distanceUnit === DistanceUnit.KILOMETERS) {
    return distanceInKilometers.toFixed(decimalNumbers)
  }

  return (distanceInKilometers / MILE_FACTOR).toFixed(decimalNumbers)
}

onMounted(() => {
  tripDistance.value = getTripDistance()
})
// Open Functionality ----------------------------------------------------------

const internalValue = ref(false)
const isOpen = computed({
  get: () => props.value || internalValue.value,
  set: (value) => {
    internalValue.value = value
    emit('input', value)
  },
})

// Track when dialog opens
watch(
  () => isOpen.value,
  (newValue) => {
    if (newValue) {
      logEvent('trip_share_dialog_opened')
    }
  },
)

function closeDialog() {
  logEvent('trip_share_dialog_closed')
  isOpen.value = false
}

return { __sfc: true,props, emit, trip, tripImage, tripDays, getTripDays, tripSettings, tripDistance, getTripDistance, internalValue, isOpen, closeDialog, TripShareSectionCanEdit, TripShareSectionViewOnly, DistanceUnit }
}

})